"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "isRequiredIf", {
  enumerable: true,
  get: function get() {
    return _isRequiredIf["default"];
  }
});
var _isRequiredIf = _interopRequireDefault(require("./isRequiredIf"));